<template>
  <div class="summary-panel">
    <div v-for="item in summaryCards" :key="item.name" class="summary-card">
      <div class="summary-icon">{{ item.icon }}</div>
      <div class="summary-text">
        <span>{{ item.name }}</span>
        <strong>{{ item.value }}</strong>
      </div>
    </div>
  </div>
</template>

<script setup>
const summaryCards = [
  { name: "总供水", value: "3260吨", icon: "✓" },
  { name: "已分配", value: "2680吨", icon: "✓" },
  { name: "剩余可调", value: "580吨", icon: "↗" },
];
</script>

<style lang="less" scoped>
.summary-panel {
  width: 100%;
  height: 100%;

  min-height: 0;
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  grid-auto-rows: 1fr;
  gap: 100px;
  padding: 64px 0 18px;
  box-sizing: border-box;
}

.summary-card {
  position: relative;
  min-width: 0;
  min-height: 0;
  display: flex;
  align-items: center;
  padding: 0 34px;
  box-sizing: border-box;
  // background: linear-gradient(135deg, rgba(8, 93, 84, 0.84), rgba(1, 53, 53, 0.98));
  border: 1px solid rgba(105, 255, 244, 0.68);
  border-radius: 8px;
  box-shadow: inset 0 0 40px rgba(90, 255, 242, 0.2),
    0 0 12px rgba(68, 255, 241, 0.14);

  &:last-child {
    grid-column: 1 / 2;
  }
}

.summary-icon {
  width: 74px;
  height: 74px;
  border-radius: 50%;
  margin-right: 28px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #7efff5;
  font-size: 46px;
  font-weight: bold;
  border: 2px solid rgba(85, 255, 242, 0.38);
  box-shadow: inset 0 0 18px rgba(85, 255, 242, 0.18);
}

.summary-text {
  min-width: 0;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  color: #fff;
  font-weight: bold;

  span {
    font-size: 30px;
    line-height: 1;
  }

  strong {
    margin-top: 12px;
    font-size: 42px;
    line-height: 1;
  }
}
</style>
